// Angular
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatIconModule } from '@angular/material/icon';
import {
  MatDialogConfig,
  MatDialogModule,
  MAT_DIALOG_DEFAULT_OPTIONS,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

// Components
import { QuickSearchComponent } from '@sharedComponents/quick-search/quick-search.component';
import { AppWarningComponent } from '@sharedComponents/app-warning/app-warning.component';
import { AdminPaginationComponent } from '@sharedComponents/admin-pagination/admin-pagination.component';
import { DatesService } from '@sharedServices/dates.service';
import { DatePickerModule } from '@sharedComponents/date-picker/date-picker.module';
import { DotsLoaderComponent } from '@sharedComponents/dots-loader/dots-loader.component';
import { SelectAllOptionComponent } from '@sharedComponents/select-all-option/select-all-option.component';

// Third Party
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FilterableTableComponent } from '@sharedComponents/filterable-table/filterable-table.component';
import { ToolTipComponent } from '@sharedComponents/filterable-table/tool-tip/tool-tip.component';
import { RowHeaderComponent } from '@sharedComponents/filterable-table/row-header/row-header.component';
import { RowChildComponent } from '@sharedComponents/filterable-table/row-child/row-child.component';
import { CellContentPipe } from '@sharedComponents/filterable-table/pipes/cellcontent.pipe';
import { Dropdown } from '@sharedComponents/filterable-table/directives/dropdown.directive';
import { DropdownToggle } from '@sharedComponents/filterable-table/directives/dropdown-toggle.directive';
import {
  reducers,
  FEATURE_REDUCER_TOKEN as frt,
} from '@sharedComponents/filterable-table/store';
import { StoreModule } from '@ngrx/store';

export function getReducers() {
  return reducers;
}

export const FEATURE_REDUCER_TOKEN = frt;

@NgModule({
  declarations: [
    QuickSearchComponent,
    AppWarningComponent,
    DotsLoaderComponent,
    AdminPaginationComponent,
    SelectAllOptionComponent,
    FilterableTableComponent,
    ToolTipComponent,
    RowHeaderComponent,
    RowChildComponent,
    CellContentPipe,
    Dropdown,
    DropdownToggle,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DatePickerModule,
    NgxMaskDirective,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    StoreModule.forFeature('FILTERABLE_TABLE', FEATURE_REDUCER_TOKEN),
  ],
  exports: [
    QuickSearchComponent,
    FormsModule,
    ReactiveFormsModule,
    AppWarningComponent,
    DotsLoaderComponent,
    DatePickerModule,
    AdminPaginationComponent,
    NgxMaskDirective,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    SelectAllOptionComponent,
    FilterableTableComponent,
    ToolTipComponent,
    RowHeaderComponent,
    RowChildComponent,
    CellContentPipe,
    Dropdown,
    DropdownToggle,
  ],
  providers: [
    DatesService,
    DatePipe,
    CurrencyPipe,
    provideNgxMask(),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { ...new MatDialogConfig(), autoFocus: false },
    },
    {
      provide: FEATURE_REDUCER_TOKEN,
      useFactory: getReducers,
    },
  ],
})
export class SharedModule {
  constructor() {}

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
